import {
  GET_BRANCHES,
  GET_BRANCH,
  ADD_BRANCH,
  UPDATE_BRANCH,
  DELETE_BRANCH,
  BRANCH_ERROR,
  BRANCH_LOADING,
} from "./types";

const BASE_URL_PROVIDERS = process.env.REACT_APP_API_URL;

const getToken = () => {
  const uid = localStorage.getItem("uid");
  return uid ? JSON.parse(uid).token : "";
};

// ✅ Get All by Provider
export const getBranches = (providerId) => async (dispatch) => {
  dispatch({ type: BRANCH_LOADING });
  try {
    const res = await fetch(
      `${BASE_URL_PROVIDERS}/provider-branch/get_branches_by_provider_id/${providerId}`,
      {
        method: "GET",
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    const data = await res.json();
    dispatch({ type: GET_BRANCHES, payload: data.data || [] });
  } catch (err) {
    dispatch({ type: BRANCH_ERROR, payload: err.message });
  }
};

// ✅ Get One
export const getBranch = (branchId) => async (dispatch) => {
  dispatch({ type: BRANCH_LOADING });
  try {
    const res = await fetch(
      `${BASE_URL_PROVIDERS}/provider-branch/get_branch/${branchId}`,
      {
        method: "GET",
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    const data = await res.json();
    dispatch({ type: GET_BRANCH, payload: data.result });
  } catch (err) {
    dispatch({ type: BRANCH_ERROR, payload: err.message });
  }
};

// ✅ Add
export const addBranch = (payload) => async (dispatch) => {
  
  try {
    const res = await fetch(
      `${BASE_URL_PROVIDERS}/provider-branch/add_branch`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload),
      }
    );
    const data = await res.json();
    dispatch({ type: ADD_BRANCH, payload: data.data });
    dispatch(getBranches(payload.providerId)); // refresh list
  } catch (err) {
    dispatch({ type: BRANCH_ERROR, payload: err.message });
  }
};

// ✅ Update
export const updateBranch = ({payload}) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_URL_PROVIDERS}/provider-branch/update_branch`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );
    const data = await res.json();
    dispatch({ type: UPDATE_BRANCH, payload: data.result });
    dispatch(getBranches(payload.providerId));
  } catch (err) {
    dispatch({ type: BRANCH_ERROR, payload: err.message });
  }
};

// ✅ Delete
export const deleteBranch = ({ branchId, providerId }) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_URL_PROVIDERS}/provider-branch/delete_branch/${branchId}`,
      {
        method: "DELETE"
      }
    );
    await res.json();
    dispatch({ type: DELETE_BRANCH, payload: branchId });
    dispatch(getBranches(providerId));
  } catch (err) {
    dispatch({ type: BRANCH_ERROR, payload: err.message });
  }
};
